export default __webpack_public_path__ + "static/media/botas-largas-hombre.7c1f2fcc.png";